export const CONTRACT_TYPES = ['Pro', 'Standard', 'Lite'];
export const PRICING_MODEL_TYPES = [
  { code: 'PEPM', value: 'per_employee_per_month' },
  { code: 'Fixed', value: 'fixed' },
  { code: 'Intra company', value: 'intra_company' },
  { code: 'Usage based', value: 'usage_based' },
];

export const MODEL_TYPE_HEADERS = [
  'Member Count Range (From)',
  'Member Count Range (To)',
  'Currency',
  'Amount per member',
  'Action',
];

export const PRICING_MODELS_FIELDS = {
  FIXED: {
    radioBtnLabel: 'Pricing duration',
    charFieldLabel: 'Pricing amount',
    charFieldName: 'pricing_amount',
  },
  USAGE_BASED: {
    radioBtnLabel: 'Platform fee',
    charFieldLabel: 'Platform amount',
    charFieldName: 'platform_fee',
  },
};

export const ROLES = [
  { value: 'HR', code: 'HR manager' },
  { value: 'payout', code: 'Payroll officer' },
  { value: 'invoicing', code: 'Contact for invoices' },
  { value: 'other', code: 'Other' },
];

export const ALL_CONTRACTS_TABLE_HEADERS = [
  { id: 'contract', label: 'Contract' },
  { id: 'companyName', label: 'Company', serverOrdered: true },
  { id: 'owner', label: 'Legal entity' },
  { id: 'productLine', label: 'Product line', serverOrdered: true },
  { id: 'type', label: 'Type', serverOrdered: true },
  { id: 'signedDate', label: 'Signing date', serverOrdered: true },
  { id: 'status', label: 'Status' },
  { id: 'benefits', label: 'Benefits plan' },
];

export const MEMBERS_TABLE_HEADERS = [
  { id: 'fullName', label: 'Member name' },
  { id: 'companyName', label: 'Customer' },
  { id: 'countryOfEmployment', label: 'Country of employment' },
  { id: 'availableProductLines', label: 'Product line' },
  { id: 'assignedCareExpert', label: 'Care expert' },
  { id: 'status', label: 'Status' },
  { id: 'memberJourney', label: 'Activated Product' },
  { id: 'ticketStatus', label: 'Tickets' },
];

export const LATEST_CONTRACTS_TABLE_HEADERS = [
  'Contract',
  'Company name',
  'Contract type',
  'Start date',
  'End date',
  'Action',
];

export const BENEFITS_PLAN_STEPS = ['Configurations', 'Integration'];
export const BENEFITS_PLAN_DETAILS_TABS = [
  'Plan Name',
  'Countries',
  'Entities',
  'Budget',
  'Eligible treatment',
  'Taxation',
  'Reimbursement configurations',
  'Marketplace',
];

export const CLAIMS_TABLE_HEADERS = [
  { id: 'claimId', label: 'Claim ID' },
  { id: 'customerName', label: 'Customer name' },
  { id: 'country', label: 'Country of employment' },
  { id: 'memberName', label: 'Member name' },
  { id: 'careExpert', label: 'Care expert' },
  { id: 'claimDate', label: 'Claim date' },
  { id: 'submissionDate', label: 'Submission date' },
  { id: 'amount', label: 'Requested amount' },
  { id: 'awarded', label: 'Awarded amount' },
  { id: 'status', label: 'Status' },
  { id: 'taxationStatus', label: 'Taxation status' },
  {
    id: 'medicallyNecessaryProofDueInDays',
    label: 'Medically necessary status',
  },
];

export const WALLETS_TABLE_HEADERS = [
  { label: 'Wallet ID', size: '5%' },
  { label: 'Status', size: '10%' },
  { label: 'Customer Name', size: '15%' },
  { label: 'Country of Employment', size: '15%' },
  { label: 'Country of Treatment', size: '15%' },
  { label: 'Member Name', size: '15%' },
  { label: 'Reconciliation', size: '10%' },
  { label: 'Date of Creation', size: '10%' },
  { label: 'Treatment Plan', size: '20%' },
];

export const TRANSACTIONS_TABLE_HEADERS = [
  { id: 'pliantId', label: 'Transaction ID' },
  { id: 'walletId', label: 'Wallet ID' },
  { id: 'transactionAmount', label: 'Transaction Amount' },
  { id: 'awardedAmount', label: 'Awarded Amount' },
  { id: 'refundedAmount', label: 'Refunded amount' },
  { id: 'companyName', label: 'Customer Name' },
  { id: 'country', label: 'Country of Employment' },
  { id: 'countryOfTreatment', label: 'Country of Treatment' },
  { id: 'memberName', label: 'Member Name' },
  { id: 'createdAt', label: 'Transaction Date' },
  { id: 'reconciliationStatus', label: 'Reconciliation status' },
  { id: 'taxationStatus', label: 'Taxation status' },
  {
    id: 'medicallyNecessaryProofDueInDays',
    label: 'Medically necessary status',
  },
];

export const BENEFITS_PLAN_DETAILS_TABS_FOR_STANDARD = [
  'Plan Name',
  'Countries',
  'Entities',
  'Marketplace',
];

export const BUDGET_TAB_TABLE_HEADERS = [
  { name: 'Countries', width: '55%' },
  { name: 'Currency', width: '10%' },
  { name: 'Amount', width: '20%' },
];

export const MONTHS = [
  { name: 'January', number: 1 },
  { name: 'February', number: 2 },
  { name: 'March', number: 3 },
  { name: 'April', number: 4 },
  { name: 'May', number: 5 },
  { name: 'June', number: 6 },
  { name: 'July', number: 7 },
  { name: 'August', number: 8 },
  { name: 'September', number: 9 },
  { name: 'October', number: 10 },
  { name: 'November', number: 11 },
  { name: 'December', number: 12 },
];

export const allmonthNames = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export const STATUS_CHIP_STYLES = {
  info: { backgroundColor: '#EDEFF9', color: 'inherit' },
  success: { backgroundColor: '#F1FAF1', color: '#448046' },
  warning: { backgroundColor: '#FFF4CF', color: '#6A4B00' },
  default: { backgroundColor: '#E6E8ED', color: '#1A1919' },
};

export const MEMBER_STATUS = ['Signed up', 'Onboarded', 'Registered'];
export const MEMBER_TICKET_STATUSES = [
  {
    id: 1,
    value: 'open',
    label: 'Open',
    chip: STATUS_CHIP_STYLES.warning,
  },
  {
    id: 2,
    value: 'no_active',
    label: 'No active',
    chip: STATUS_CHIP_STYLES.default,
  },
];

export const NOTE_TYPES = [
  'Update',
  'Comment',
  'Feedback',
  'Follow-up email sent',
  'First consultation',
];

// consultation constants

export const MEMBER_CONSULTATION_TABLE_HEADERS = [
  'Date',
  'Time (CET)',
  'Care expert',
  'Topic',
  'Action',
];

export const CONSULTATIONS_TABLE_HEADERS = [
  { id: 'fullName', label: 'Member name', serverOrdered: true },
  { id: 'companyName', label: 'Customer', serverOrdered: true },
  { id: 'activeMemberJourney', label: 'Product', serverOrdered: false },
  { id: 'startTime', label: 'Date', serverOrdered: true },
  { id: 'time', label: 'Time (CET)' },
  { id: 'assignedCareExpert', label: 'Expert', serverOrdered: true },

  {
    id: 'genderIdentity',
    label: 'Gender',
    serverOrdered: true,
    accountManagersOnly: true,
  },

  {
    id: 'relationshipDynamic',

    label: 'Relationship',

    serverOrdered: true,
    accountManagersOnly: true,
  },

  {
    id: 'familyFormingJourney',
    label: 'Journey',
    serverOrdered: true,
    accountManagersOnly: true,
  },
  {
    id: 'topic',
    label: 'Topic',
    serverOrdered: true,
  },

  {
    id: 'consultationType',
    label: 'Consultation type',
    serverOrdered: true,
  },
  { id: 'language', label: 'Language', pcasOnly: true },
  { id: 'action', label: 'Action', pcasOnly: true },
];

export const CONSULTATION_TAB_LABELS = [
  'Upcoming consultations',
  'Past consultations',
];

export const SHOW_POLAR_QUESTION_ANSwer = [
  { id: 'yes', value: 'Yes' },
  { id: 'no', value: 'No' },
];

export const CONSULTATION_TOPICS = [
  { id: 'ART', value: 'Assisted reproductive treatments' },
  { id: 'fertility_assessment', value: 'Fertility Assessment' },
  { id: 'natural_conception', value: 'Natural Conception' },
  { id: 'reimbursement_activation', value: 'Reimbursement Activation' },
  { id: 'social_freezing', value: 'Social Freezing' },
  { id: 'gamete_donation', value: 'Gamete Donation' },
  { id: 'feedback_or_complaint', value: 'Feedback/Complain' },
  { id: 'other', value: 'Other' },
];

export const PREVIOUS_EXPERIENCE = [
  { id: 'yes', value: 'Yes' },
  { id: 'no', value: 'No' },
  { id: 'not_disclosed', value: 'Not disclosed' },
];

export const TREATMENT_CYCLE = [0, 1, 2, 3, 4];

export const POST_CALL_ACTION = [
  { id: 'book_appointment_at_clinic', value: 'Book appointment at clinic' },
  {
    id: 'send_follow-up_email_for_nps_activation',
    value: 'Send follow-up email for NPS activation',
  },
  { id: 'send_clinics_suggestion', value: 'Send clinics suggestion' },
  {
    id: 'deeper_research_into_requested_topic',
    value: 'Deeper research into requested topic',
  },
  { id: 'no_action', value: 'No action' },
];

export const NON_EDITABLE_NOTE_TYPES = [
  /* 'Comment',
  'Update',
  'Feedback',
  'Follow-up email sent',
  'First consultation', */
  'Assign Care Expert',
  'Appointment booked',
  'Process started',
  'Process paused',
  'Process stopped',
  'Process finished',
  'Budget reset',
];

// Secret Key of encrypt & decrypt
export const SECRET_KEY = '.u-U8x2HUejaYirfLi!YnHUvAHJC9FzgFEA.y@No';

// sactioned country list of bank payments
export const SACTIONED_COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Armenia',
  'Azerbaijan',
  'Syria',
  'Belarus',
  'Bosnia & Herzegovina',
  'Burma',
  'Burundi',
  'Central African Republic',
  'China',
  'Egypt',
  'Ethiopia',
  'Guinea',
  'Guinea-Bissau',
  'Haiti',
  'Iraq',
  'Ivory Coast',
  'North Korea',
  'Kosovo',
  'Lebanon',
  'Liberia',
  'Libya',
  'Macedonia',
  'Maldives',
  'Mali',
  'Nicaragua',
  'Serbia',
  'Montenegro',
  'Somalia',
  'South Sudan',
  'Sudan',
  'Tunisia',
  'Ukraine',
  'Venezuela',
  'Yemen',
  'Zimbabwe',
];

export const DEFAULT_PRODUCT_LINE = 'fertility';
export const DEFAULT_CONTRACT_TYPE = 'standard';

export const DEFAULT_CHIP_COLOR = '#FFF';
export const PRODUCT_LINE_CHIP_COLORS = {
  fertility: '#2D3E91',
  menopause: '#BFC9F8',
  'pregnancy and postpartum': '#E1F4F7',
};

export const TEXTAREA_ROWS = {
  COLLAPSED: 1,
  EXPANDED: 5,
};

// product lines
export const FERTILITY = 'Fertility';
export const MENOPAUSE = 'Menopause';
export const PREGNANCY_ANDPOSTPARTUM = 'Pregnancy and Postpartum';

export const RECIPIENT_OPTIONS = [
  { key: 'member', label: 'Member' },
  { key: 'partner', label: 'Partner' },
  { key: 'both', label: 'Both' },
];

// Treatment plan status
export const VALIDATE = 'validate'; // Default value
export const VERIFIED = 'verify';
export const IN_VALIDATION = 'in_validation';
export const REQUEST_REUPLOAD = 'documents_requested';
export const TRANSACTION_DRAFT_RECONCILIATION_STATUSES = [
  'in_validation',
  'validation_pending_1',
];
export const REJECTED = 'rejected';
export const APPROVED = 'approved';
export const COVERED = 'covered';
export const SAVE_DRAFT = 'save_draft';
export const PARTIAL = 'partial';
export const FULLY_REFUNDED = 'fully_refunded';
export const REFUND = 'REFUND';

// Taxation status
export const TAXATION_STATUSES = [
  { value: 'required', label: 'Required' },
  { value: 'not_required', label: 'Not required' },
  { value: 'done', label: 'Done' },
];

// model names

export const AI_MODELS = [
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-3-sonnet-20240229-v1:0',
    name: 'Claude 3 Sonnet',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-3-haiku-20240307-v1:0',
    name: 'Claude 3 Haiku',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.amazon.nova-micro-v1:0',
    name: 'Nova Micro',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.amazon.nova-lite-v1:0',
    name: 'Nova Lite',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-sonnet-4-20250514-v1:0',
    name: 'Claude Sonnet 4',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.amazon.nova-pro-v1:0',
    name: 'Nova Pro',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-sonnet-4-5-20250929-v1:0',
    name: 'Claude Sonnet 4.5',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-haiku-4-5-20251001-v1:0',
    name: 'Claude Haiku 4.5',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.amazon.nova-2-lite-v1:0',
    name: 'Nova 2 Lite',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-opus-4-5-20251101-v1:0',
    name: 'Claude Opus 4.5',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-opus-4-6-v1',
    name: 'Claude Opus 4.6',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-sonnet-4-6',
    name: 'Claude Sonnet 4.6',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-opus-4-7',
    name: 'Claude Opus 4.7',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-opus-4-8',
    name: 'Claude Opus 4.8',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.anthropic.claude-fable-5',
    name: 'Claude Fable 5',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.meta.llama3-2-3b-instruct-v1:0',
    name: 'EU Meta Llama 3.2 3B Instruct',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.meta.llama3-2-1b-instruct-v1:0',
    name: 'EU Meta Llama 3.2 1B Instruct',
  },
  {
    id: 'arn:aws:bedrock:eu-central-1:038112492495:inference-profile/eu.mistral.pixtral-large-2502-v1:0',
    name: 'EU Mistral Pixtral Large 25.02',
  },
];
